module.exports = __webpack_public_path__ + "img/refresh-circle-white.fde41b45.svg";